import React, { useState, useEffect } from "react";
import "./LoginSignup.css";
import register from "../../Images/register.svg";
import log from "../../Images/log.svg";

import { Link } from "react-router-dom";
import { useNavigate } from "react-router-dom";

import alumnisocialcorner from "../images/Yellow Line Art People Logo (1).png";
import { useDispatch, useSelector } from "react-redux";
import {
  loginUser,
  loginUserByGoogle,
  loginUserByFacebook,
} from "../../Actions/userActions";
import { GoogleLogin } from "react-google-login";
import FacebookLogin from "react-facebook-login";
import Swal from "sweetalert2";
import "react-phone-number-input/style.css";
import PhoneInput from "react-phone-number-input";
import { registerUser } from "../../Actions/userActions";
import AES from "crypto-js/aes";
import VisibilityIcon from "@mui/icons-material/Visibility";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
import { IconButton } from "@mui/material";
import api from "../../utils/api";

const swalWithBootstrapButtons = Swal.mixin({
  customclassName: {
    confirmButton: "btn btn-success",
    cancelButton: "btn btn-danger",
  },
  buttonsStyling: false,
});

const LoginSignup = () => {
  const [mode, setMode] = useState("login");
  /************ login logic */
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [isFbLoginClicked, setIsFbLoginClicked] = useState(false);
  const [loginErrors, setLoginErrs] = useState({});
  const [seeLoginPassword, setSeeLoginPassword] = useState(false);
  const [seeSignupPassword, setSeeSignupPassword] = useState(false);
  const [userIdentityImage, setUserIdentityImage] = useState("");
  const uploadPhoto = async (e) => {
    console.log("e.target", e.target);
    console.log("running upload file ");
    let files = e.target.files;
    if (files?.length > 0) {
      const signResponse = await api.get("/signuploadform");
      const signData = await signResponse.data;
      console.log("sign data", signData);
      // return;
      /****** */
      const data = new FormData();

      data.append("file", files[0]);
      // data.append("upload_preset", "klv1irxe");
      data.append("api_key", signData.apikey);
      data.append("timestamp", signData.timestamp);
      data.append("signature", signData.signature);
      data.append("eager", "c_fill,h_400,w_600");
      // data.append("eager", "c_pad,h_100,w_500|c_crop,h_100,w_500");
      try {
        const res = await fetch(
          "https://api.cloudinary.com/v1_1/" +
            signData.cloudname +
            "/auto/upload",

          {
            method: "POST",
            body: data,
          }
        );
        const file = await res.json();
        console.log("response from cloudinary>>>", file);
        // setImage(file?.eager[0]?.secure_url);
        setUserIdentityImage(file?.secure_url);

        let e2 = { target: { name: "image", value: file.secure_url } };
      } catch (err) {
        console.log("error while uploading images", err);
      }
    }
  };
  const [loginData, setLoginData] = useState({
    email: "",
    password: "",
  });
  const [userRoleValue, setUserRoleValue] = useState("student");

  const onLoginChange = (e) => {
    console.log(e);
    const updatedLoginData = Object.assign(loginData, {
      [e.target.name]: e.target.value,
    });
    setLoginData(updatedLoginData);
    console.log("login data", updatedLoginData);
    document.getElementById(e.target.name).value = e.target.value;
  };
  const login = () => {
    let errs = {};

    if (!loginData.password) {
      errs.password = "Password is required";
    } else if (loginData.password.length < 5) {
      errs.password = "Password needs to be 6 characters or more";
    }
    if (!loginData.email) {
      errs.email = "Email is required";
    } else if (!validateEmail(loginData.email)) {
      errs.email = "Please enter a valid email";
    }
    setLoginErrs(errs);
    console.log("loginErrors>>>", errs);
    console.log("loginData>>", loginData);
    if (Object.keys(errs).length === 0 && errs.constructor === Object) {
      console.log("signup loginErrors while dispatching,", loginErrors);

      let user;

      user = {
        email: loginData.email,
        password: loginData.password,
      };

      dispatch(loginUser(user, navigate));
    }
  };
  const googleSuccess = async (res) => {
    console.log("res from google> ", res);
    dispatch(loginUserByGoogle(res,navigate));
  };

  const googleError = (err) => {
    console.log("err> ", err);
    swalWithBootstrapButtons.fire(
      "Google Sign In unsuccessful!",
      "Try again later",
      "error"
    );
    console.log("Google Sign In was unsuccessful. Try again later");
  };
  const responseFacebook = (res) => {
    console.log("response from facebook>", res);
    if (res.id && isFbLoginClicked) {
      dispatch(loginUserByFacebook(res));

      setIsFbLoginClicked(false);
    } else {
      console.log("err");
      swalWithBootstrapButtons.fire(
        "Facebook Sign In unsuccessful!",
        "Try again later",
        "error"
      );
    }
  };
  /************************ */
  /*****register logic */
  const [errors, setErrors] = useState({});
  const [phoneValue, setPhoneValue] = useState("");
  const [data, setData] = useState({
    name: "",
    email: "",
    userRole: "",
    gender: "",
    password: "",
    userIdentityFile: "",
    phone: "",
    address: "",
  });
  const onChange = (e) => {
    console.log("e at onchange ", e);
    const updatedData = Object.assign(data, {
      [e.target.name]: e.target?.value,
    });
    setData(updatedData);
    console.log("updated data", updatedData);

    if (
      e.target.name !== "phone" &&
      e.target.name !== "userRole" &&
      e.target.name !== "userIdentityFile"
    ) {
      document.getElementById(e.target.name).value = e.target?.value;
    }
  };
  useEffect(() => {
    let e = {
      target: {
        name: "userRole",
        value: userRoleValue,
      },
    };
    onChange(e);
  }, [userRoleValue]);
  useEffect(() => {
    let e = {
      target: {
        name: "userIdentityFile",
        value: userIdentityImage,
      },
    };
    onChange(e);
  }, [userIdentityImage]);
  useEffect(() => {
    let e = {
      target: {
        name: "phone",
        value: phoneValue,
      },
    };
    onChange(e);
  }, [phoneValue]);
  const signUp = () => {
    let errs = {};
    if (!data.name) {
      errs.name = "Name is required";
    } else if (!onlyLettersAndSpaces(data.name)) {
      errs.name = "enter correct name";
    }
    if (!data.password) {
      errs.password = "Password is required";
    } else if (data.password.length < 5) {
      errs.password = "Password needs to be 6 characters or more";
    }
    if (!onlyLettersAndSpaces(data.name)) {
      errs.name = "enter correct name";
    }
    if (!data.email) {
      errs.email = "Email is required";
    } else if (!validateEmail(data.email)) {
      errs.email = "Please enter a valid email";
    }
    if (!data.phone) {
      errs.phone = "phone is required";
    }
    if (!data.address) {
      errs.address = "address is required";
    }
    // if (!data.university) {
    //   errs.university = "university name is required";
    // } else if (!onlyLettersAndSpaces(data.university)) {
    //   errs.university = "enter appropriate university name";
    // }
    if (!data.gender) {
      errs.gender = "gender is required";
    } else if (
      data.gender.toLocaleLowerCase() != "male" &&
      data.gender.toLocaleLowerCase() != "female" &&
      data.gender
    ) {
      errs.gender = "Enter appropriate gender e.g. Male or Female";
    }
    if (!data.userRole) {
      errs.userRole = "role is required";
    }
    if (!data.userIdentityFile) {
      errs.userIdentityFile = " required";
    }

    setErrors(errs);
    console.log("errors>>>", errs);
    console.log("data>>", data);
    if (Object.keys(errs).length === 0 && errs.constructor === Object) {
      console.log("signup errors while dispatching,", errors);
      var pass = AES.encrypt(data.password, "alumnisocialcorner").toString();
      let user;

      user = {
        name: data.name,
        email: data.email,
        pass,
        userRole: data.userRole.toLocaleLowerCase(),
        gender: data.gender.toLocaleLowerCase(),
        userIdentityFile: data.userIdentityFile,
        phone: data.phone,
        address: data.address,
      };

      dispatch(registerUser(user, navigate));
    }
  };
  /************ */
  return (
    <div>
      <div
        className={
          mode == "login" ? "containerLogSig" : "containerLogSig sign-up-mode"
        }
      >
        <div className="forms-container">
          <div className="signin-signup">
            <form className="sign-in-form">
              <h2 className="title">Sign in</h2>

              <div className="input-field">
                <i className="fas fa-user"></i>
                <input
                  type="email"
                  placeholder="Email"
                  id="email"
                  name="email"
                  onChange={(e) => onLoginChange(e)}
                />
              </div>
              <div className="input-field showEyeWrapper">
                <i className="fas fa-lock"></i>
                <input
                  type={seeLoginPassword ? "text" : "password"}
                  placeholder="Password"
                  id="password"
                  name="password"
                  onChange={(e) => onLoginChange(e)}
                />
                <IconButton
                  onClick={() => setSeeLoginPassword(!seeLoginPassword)}
                  className="showEye"
                >
                  <VisibilityIcon />
                </IconButton>
              </div>
              {/* <div className="see__password__box">
                <input
                  type="checkbox"
                  isChecked={seeLoginPassword}
                  onChange={() => setSeeLoginPassword(!seeLoginPassword)}
                />
                <span>see password</span>
              </div> */}
              <span
                type="text"
                className="asc__submit__form__button"
                onClick={() => login()}
                style={{ width: "100px" }}
                disabled
              >
                Login
              </span>
              {/* <button
                className="asc__submit__form__button"
                onClick={() => login()}
                style={{ padding: "7px 30px" }}
              >
                Login
              </button> */}

              <div className="forgot-password mt-3">
                <p className="text-left">
                  <span>
                    <button onClick={() => navigate("/forgot-password")}>
                      Forgot Password?
                    </button>
                  </span>
                </p>
              </div>
              <p className="social-text">Or Sign in with social platforms</p>
              <div className="social-media">
                {/* <button
                  href="#"
                  onClick={() => {
                    setIsFbLoginClicked(true);
                  }}
                >
                  <a href="#" className="social-icon">
                    <i className="fab fa-facebook-f"></i>
                  </a>
                  {isFbLoginClicked && (
                    <FacebookLogin
                      appId="362107689224548"
                      autoLoad={true}
                      fields="name,email,picture"
                      callback={responseFacebook}
                      cssClass="btnFacebook facebook__login__btn"
                    />
                  )}
                </button> */}
                {/* <a href="#" className="social-icon">
                  <i className="fab fa-twitter"></i>
                </a> */}
                <GoogleLogin
                  // clientId="397548666254-aifv81uplfldiejuvi1id8cgfnvumabk"
                  clientId="845412415462-rpovhl6omgbic67r8184o1frlj4r72np.apps.googleusercontent.com"
                  render={(renderProps) => (
                    // <a
                    //   href="/"
                    //   classNameName="google-btn googleButton"
                    //   onClick={renderProps.onClick}
                    //   disabled={renderProps.disabled}
                    // >
                    //   <i classNameName="fa fa-google fa-fw"></i> Login with Google+
                    // </a>
                    <a
                      href="/"
                      className="social-icon "
                      onClick={renderProps.onClick}
                      disabled={renderProps.disabled}
                    >
                      <i className="fab fa-google"></i>
                    </a>
                  )}
                  onSuccess={googleSuccess}
                  onFailure={googleError}
                  cookiePolicy="single_host_origin"
                />

                {/* <a href="#" className="social-icon">
                  <i className="fab fa-linkedin-in"></i>
                </a> */}
              </div>
            </form>
            <form
              //   style={{ maxHeight: "500px", overflowY: "auto" }}

              className="sign-up-form"
            >
              <h2 className="title">Sign up</h2>
              <div className="input-field">
                <i className="fas fa-user"></i>
                <input
                  type="text"
                  placeholder="Name"
                  id="name"
                  name="name"
                  required
                  onChange={(e) => onChange(e)}
                />
              </div>
              {errors.name && (
                <h6 className="signup__error__message">{errors.name}</h6>
              )}
              <div className="input-field">
                <i className="fas fa-envelope"></i>
                <input
                  type="email"
                  placeholder="Email"
                  id="email"
                  name="email"
                  required
                  onChange={(e) => onChange(e)}
                />
              </div>
              {errors.email && (
                <h6 className="signup__error__message">{errors.email}</h6>
              )}
              <div className="input-field showEyeWrapper">
                <i className="fas fa-lock"></i>
                <input
                  type={seeSignupPassword ? "text" : "password"}
                  placeholder="Password"
                  id="password"
                  name="password"
                  required
                  onChange={(e) => onChange(e)}
                />
                <IconButton
                  className="showEye"
                  onClick={() => setSeeSignupPassword(!seeSignupPassword)}
                >
                  <VisibilityIcon />
                </IconButton>
              </div>
              {errors.password && (
                <h6 className="signup__error__message">{errors.password}</h6>
              )}
              {/* <div className="see__password__box">
                <input
                  type="checkbox"
                  isChecked={seeLoginPassword}
                  onChange={() => setSeeSignupPassword(!seeSignupPassword)}
                />
                <span>see password</span>
              </div> */}
              <div className="input-field">
                <i></i>
                <PhoneInput
                  placeholder="Enter phone number"
                  // className="text-feild firstdiv_of_projects"
                  className="my-3 w-full bg-gray-100 bg-opacity-50 focus:border-indigo-500 focus:bg-white focus:ring-2 focus:ring-indigo-200 text-base outline-none text-gray-700 py-1 px-3 leading-8 transition-colors duration-200 ease-in-out"
                  // value={phoneValue}
                  onChange={(value) => setPhoneValue(value)}
                />
              </div>
              {errors.phone && (
                <h6 className="signup__error__message">{errors.phone}</h6>
              )}
              <div className="input-field">
                <i className="fas fa-home"></i>
                <input
                  type="text"
                  placeholder="Address"
                  id="address"
                  name="address"
                  required
                  onChange={(e) => onChange(e)}
                />
              </div>
              {errors.address && (
                <h6 className="signup__error__message">{errors.address}</h6>
              )}
              <div className="radio-field-box">
                <label> Gender</label>
                <div>
                  {" "}
                  <div className="ml-10">
                    <input
                      type="radio"
                      name="gender"
                      onClick={(e) => {
                        let event = {
                          target: {
                            name: "gender",
                            value: "male",
                          },
                        };
                        onChange(event);
                      }}
                    />
                    <label className="ml-2 text-sm">Male</label>
                  </div>
                  <div className="ml-12">
                    <input
                      type="radio"
                      name="gender"
                      onClick={(e) => {
                        let event = {
                          target: {
                            name: "gender",
                            value: "female",
                          },
                        };
                        onChange(event);
                      }}
                    />
                    <label className="ml-2 text-sm">Female</label>
                  </div>
                </div>
              </div>
              {errors.gender && (
                <h6 className="signup__error__message">{errors.gender}</h6>
              )}
              <div className="radio-field-box">
                {/* <i className="fas fa-home"></i> */}
                {/* <input
                  type="text"
                  placeholder="Address"
                  id="address"
                  name="address"
                  required
                  onChange={(e) => onChange(e)}
                /> */}
                <label> Choose your role</label>
                <div>
                  <select
                    style={{
                      width: "300px",
                      padding: "15px",
                      background: "transparent",
                      fontSize: "0.875rem",
                      color: "#AAAAAA",
                      fontWeight: "500",
                    }}
                    onChange={(e) => setUserRoleValue(e.target.value)}
                  >
                    {/* <option>N/A</option> */}
                    <option value="sudent">Student</option>
                    <option value="alumni"> Alumni</option>
                    <option value="fypSupervisor">FYP Supervisor</option>
                    <option value="hostelOwner">Hostel Owner</option>
                    <option value="companyRepresentative">
                      Company representative
                    </option>
                    <option value="sscOfficer">SSC Officer</option>
                  </select>
                </div>
              </div>
              {errors?.userRole && (
                <h6 className="signup__error__message">{errors?.userRole}</h6>
              )}
              <div className="radio-field-box">
                {/* <i className="fas fa-home"></i> */}
                {/* <input
                  type="text"
                  placeholder="Address"
                  id="address"
                  name="address"
                  required
                  onChange={(e) => onChange(e)}
                /> */}
                <label>
                  please upload your{" "}
                  {userRoleValue == "student" || userRoleValue == "alumni"
                    ? "Student Card"
                    : userRoleValue == "hostelOwner"
                    ? "CNIC"
                    : userRoleValue == "fypSupervisor"
                    ? "Faculty Card"
                    : userRoleValue == "sscOfficer"
                    ? "Staff Card"
                    : "Employee Card"}
                </label>
                <label>(scanned image)</label>
                <div style={{ padding: "0 20px" }}>
                  <input type="file" onChange={(e) => uploadPhoto(e)} />
                </div>
              </div>
              {userIdentityImage && (
                <img
                  src={userIdentityImage}
                  style={{ height: "100px", width: "auto" }}
                />
              )}
              {errors?.userIdentityFile && (
                <h6 className="signup__error__message">
                  {errors?.userIdentityFile}
                </h6>
              )}
              {/* <div className="radio-field-box">
                <label> choose status</label>
                <div>
                  {" "}
                  <div className="ml-10">
                    <input
                      type="radio"
                      name="status"
                      onClick={(e) => {
                        let event = {
                          target: {
                            name: "status",
                            value: "student",
                          },
                        };
                        onChange(event);
                      }}
                    />
                    <label className="ml-2 text-sm">Student</label>
                  </div>
                  <div className="ml-12">
                    <input
                      type="radio"
                      name="status"
                      onClick={(e) => {
                        let event = {
                          target: {
                            name: "status",
                            value: "alumni",
                          },
                        };
                        onChange(event);
                      }}
                    />
                    <label className="ml-2 text-sm">Alumni</label>
                  </div>
                </div>
              </div>
              {errors.status && (
                <h6 className="signup__error__message">{errors.status}</h6>
              )}
              <div className="radio-field-box">
                <label> choose one</label>
                <div>
                  {" "}
                  <div className="ml-10">
                    <input
                      type="radio"
                      name="current"
                      onClick={(e) => {
                        let event = {
                          target: {
                            name: "university",
                            value: "university",
                          },
                        };
                        onChange(event);
                      }}
                    />
                    <label className="ml-2 text-sm">University</label>
                  </div>
                  <div className="ml-12">
                    <input
                      type="radio"
                      name="current"
                      onClick={(e) => {
                        let event = {
                          target: {
                            name: "university",
                            value: "Company",
                          },
                        };
                        onChange(event);
                      }}
                    />
                    <label className="ml-2 text-sm">Company</label>
                  </div>
                </div>
              </div>
              {errors.university && (
                <h6 className="signup__error__message">{errors.university}</h6>
              )} */}

              <span
                type="text"
                className="asc__submit__form__button"
                onClick={() => signUp()}
                style={{ width: "100px" }}
                disabled
              >
                Sign up
              </span>
              {/* <button
                className="asc__submit__form__button"
                onClick={() => signUp()}
                style={{ width: "100px" }}
              >
                Sign Up
              </button> */}
              <p className="social-text">Or Sign up with social platforms</p>
              <div className="social-media">
                {/* <button
                  href="#"
                  onClick={() => {
                    setIsFbLoginClicked(true);
                  }}
                >
                  <a href="#" className="social-icon">
                    <i className="fab fa-facebook-f"></i>
                  </a>
                  {isFbLoginClicked && (
                    <FacebookLogin
                      appId="362107689224548"
                      autoLoad={true}
                      fields="name,email,picture"
                      callback={responseFacebook}
                      cssClass="btnFacebook facebook__login__btn"
                    />
                  )}
                </button> */}
                {/* <a href="#" className="social-icon">
                  <i className="fab fa-twitter"></i>
                </a> */}
                <GoogleLogin
                  clientId="397548666254-aifv81uplfldiejuvi1id8cgfnvumabk.apps.googleusercontent.com"
                  render={(renderProps) => (
                    // <a
                    //   href="/"
                    //   classNameName="google-btn googleButton"
                    //   onClick={renderProps.onClick}
                    //   disabled={renderProps.disabled}
                    // >
                    //   <i classNameName="fa fa-google fa-fw"></i> Login with Google+
                    // </a>
                    <a
                      href="/"
                      className="social-icon "
                      onClick={renderProps.onClick}
                      disabled={renderProps.disabled}
                    >
                      <i className="fab fa-google"></i>
                    </a>
                  )}
                  onSuccess={googleSuccess}
                  onFailure={googleError}
                  cookiePolicy="single_host_origin"
                />

                {/* <a href="#" className="social-icon">
                  <i className="fab fa-linkedin-in"></i>
                </a> */}
              </div>
            </form>
          </div>
        </div>

        <div className="panels-container">
          <div className="panel left-panel">
            <div className="content">
              <h3>New here ?</h3>
              <p>
                Lorem ipsum, dolor sit amet consectetur adipisicing elit.
                Debitis, ex ratione. Aliquid!
              </p>
              <button
                className="btn transparent"
                id="sign-up-btn"
                onClick={() => setMode("signup")}
              >
                Sign up
              </button>
            </div>
            <img src={log} className="image" alt="" />
          </div>
          <div className="panel right-panel">
            <div className="content">
              <h3>One of us ?</h3>
              <p>
                Lorem ipsum dolor sit amet consectetur adipisicing elit. Nostrum
                laboriosam ad deleniti.
              </p>
              <button
                className="btn transparent"
                id="sign-in-btn"
                onClick={() => setMode("login")}
              >
                Sign in
              </button>
            </div>
            <img src={register} className="image" alt="" />
          </div>
        </div>
      </div>
    </div>
  );
};

export default LoginSignup;

var validator = require("email-validator");
const validateEmail = (email) => {
  console.log("validating email>>>> ", email);
  let test;
  let length = email.length;
  let demail = email.slice(length - 4, length);
  console.log("demail>>>", demail);
  if (demail !== ".com") {
    return false;
  }
  let count = 0;
  let email2 = email.slice(0, length - 4);
  if (email2.includes(".com")) {
    return false;
  }
  if (
    !email.includes("@gmail.com") &&
    !email.includes("@yahoo.com") &&
    !email.includes("@hotmail.com") &&
    !email.includes("@outlook.com")
  ) {
    return false;
  }
  if (!validator.validate(email)) {
    return false;
  }
  return true;
};

function onlyLettersAndSpaces(str) {
  return /^[A-Za-z\s]*$/.test(str);
}
